import React, { useState } from 'react';

import { useAuth } from '../Contexts/AuthContext';
import { Link, useNavigate } from 'react-router-dom';

interface LoginFormProps {
  onLogin: (email: string, password: string) => void;
}

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Add email regex

const LoginForm: React.FC<LoginFormProps> = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [loginError, setLoginError] = useState<string | null>(null); // State for login error message
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    validateEmail(email);
    validatePassword(password);

    if (!email || !password) {
      setEmailError(!email ? "Email is required." : "");
      setPasswordError(!password ? "Password is required." : "");
      return;
    }

    if (emailError || passwordError) {
      console.error("Validation errors present");
      console.log(emailError, passwordError);
      return;
    }

    try {
      await login(email, password, navigate);
      onLogin(email, password);
      setLoginError(null); // Reset login error message
    } catch (error: any) {
      console.error("Login failed", error);
      setLoginError(error.message); // Set login error message
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const email = e.target.value;
    setEmail(email);
    validateEmail(email);
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const password = e.target.value;
    setPassword(password);
    validatePassword(password);
  };

  const validateEmail = (email: string) => {
    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address.");
    } else {
      setEmailError("");
    }
  };

  const validatePassword = (password: string) => {
    if (password.length < 6) {
      setPasswordError("Password must be at least 6 characters long.");
    } else {
      setPasswordError("");
    }
  };

  return (
    <>
    <section className='login-form-section'>
      <div className="d-flex justify-content-center align-items-center">
        <form onSubmit={handleSubmit} className="login-form p-4 border rounded shadow-sm bg-light">
          {loginError && <div className="alert alert-danger mt-3">{loginError}</div>} {/* Display login error message */}
          <div className="login-form__inputGroup">
            <label htmlFor="username" className="login-form__label form-label" hidden>Username</label>
            <input
              id="username"
              type="text"
              placeholder='Enter your email'
              className={`login-form__input form-control ${emailError ? 'is-invalid' : ''}`}
              value={email}
              onChange={handleEmailChange}
            />
            {emailError && <span className="text-danger">{emailError}</span>}
          </div>
          <div className="mb-3 login-form__inputGroup">
            <label htmlFor="password" className="form-label">Password</label>
            <input
              id="password"
              placeholder='Enter your password'
              type="password"
              className={`login-form__input form-control ${passwordError ? 'is-invalid' : ''}`}
              value={password}
              onChange={handlePasswordChange}
            />
            {passwordError && <span className="text-danger">{passwordError}</span>}
          </div>
          <button type="submit" className="login-form__button w-100">Login</button>
          <div className='forgot-password'>
          <Link className='link' to="/forgotPassword">Forgot Password?</Link>
        </div>
        </form>
        
      </div>
     
    </section>

    </>
  );
};

export default LoginForm;